import React from 'react';
import LoonaBigLogo from 'assets/livenicons/loona_logo.svg';

import styles from './styles.module.scss';

interface LivenLogoProps {
  className?: string;
}

export const LivenLogoHeader = ({ className }: LivenLogoProps) => {
  return (
    <div
      className={`${styles.container} ${className}`}
      onClick={() => window.location.reload()}
    >
      <div className={styles.contentWrapper}>
        <img src={LoonaBigLogo} alt="" />
      </div>
    </div>
  );
};
